import { render, staticRenderFns } from "./SertifikasiRpl.vue?vue&type=template&id=51e3cb07&"
import script from "./SertifikasiRpl.vue?vue&type=script&lang=js&"
export * from "./SertifikasiRpl.vue?vue&type=script&lang=js&"
import style0 from "./SertifikasiRpl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports